import { MeasureController } from "../../MeasureController";
import { JudgmentResult, JudgmentResultType } from "../../types.client";
import { AcVoltageMeasure } from "../../../models/schemas/measures/electrical.schema";
import { AC_VOLTAGE_THRESHOLDS } from "../../constants/judgmentCriteria";

/**
 * AC 입력 전압 컨트롤러
 * 판정 기준:
 * - 양호(GOOD): ±5% 이내
 * - 주의(CAUTION): ±5% 초과 ~ ±10% 이내
 * - 불량(BAD): ±10% 초과
 */
export class AcVoltageController extends MeasureController<AcVoltageMeasure> {
  protected getDefaultData(): AcVoltageMeasure {
    return {
      ratedVoltage: 0,
      measuredVoltage: 0,
      result: null,
      discussion: "",
      remark: "",
      photo: { checkUrl: "", resultUrl: "" },
    };
  }

  protected judge(): JudgmentResult {
    const { ratedVoltage, measuredVoltage } = this.data;

    // 데이터 미입력 시
    if (!ratedVoltage || !measuredVoltage) {
      return {
        result: "NA",
        discussion: this.generateDiscussion("NA"),
      };
    }

    // 판정: 3단계 (양호 ±5%, 주의 ±10%, 불량 ±10% 초과)
    const goodTolerance = ratedVoltage * AC_VOLTAGE_THRESHOLDS.good; // ±5%
    const cautionTolerance = ratedVoltage * AC_VOLTAGE_THRESHOLDS.caution; // ±10%
    const deviation = Math.abs(measuredVoltage - ratedVoltage);

    let result: JudgmentResultType;
    if (deviation <= goodTolerance) {
      result = "GOOD";
    } else if (deviation <= cautionTolerance) {
      result = "CAUTION";
    } else {
      result = "BAD";
    }

    return {
      result,
      discussion: this.generateDiscussion(result),
    };
  }

  protected generateDiscussion(result: JudgmentResultType): string {
    if (result === "NA") {
      return "데이터 미입력";
    }
    if (result === "GOOD") {
      return "AC 입력 전압이 정격 전압 대비 ±5% 이내로 양호";
    }
    if (result === "CAUTION") {
      return "AC 입력 전압이 정격 전압 대비 ±5% 초과 ±10% 이내로 주의 필요";
    }
    return "AC 입력 전압이 정격 전압 대비 ±10% 범위를 벗어남. 점검 필요";
  }
}
